import { render } from "./LabeledInput.vue?vue&type=template&id=0cc2a1a7"
import script from "./LabeledInput.vue?vue&type=script&lang=js"
export * from "./LabeledInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__